import React from 'react';
import { WorkIntroduction } from './WorkIntroduction';
import { ProjectCard } from './ProjectCard';

import BNY_Data_Vault from '../Images/BNY_Data_Vault.jpeg';
import Century_Tech_Ipad from '../Images/century_ipad_new.webp';
import agora_stream from '../Images/agora_stream_logo.png';
import tutor_stock from '../Images/tutoring_stock.jpg';

const workItems = [
  {
    title: 'Data & Analytics Associate',
    subtitle: 'BNY',
    year: '2021',
    description:
      'Building data management solutions for buy-side clients, with a focus on automation, cost efficiencies, and actionable insight.',
    imageSrc: BNY_Data_Vault,
    link: 'https://www.bny.com/corporate/global/en/solutions/platforms/data-and-analytics.html',
    buttonText: 'Read more',
  },
  {
    title: 'Science Content Team',
    subtitle: 'Century Tech',
    year: '2019',
    description:
      'Developed interactive science curriculum content for learners while immersed in a fast-moving scale-up environment.',
    imageSrc: Century_Tech_Ipad,
    link: 'https://www.century.tech/',
    buttonText: 'Read more',
  },
  {
    title: 'Software Developer',
    subtitle: 'Agora.stream (now Cassyni)',
    year: '2021',
    description:
      'Full stack developer for a research seminar platform using React, Flask, and Python, supporting a growing startup.',
    imageSrc: agora_stream,
    link: 'https://cassyni.com/',
    buttonText: 'Read more',
  },
  {
    title: 'Physics Tutor',
    subtitle: 'A-level',
    year: '2021',
    description:
      'Tutored A-level physics students and focused on clarity, confidence, and problem-solving outcomes.',
    imageSrc: tutor_stock,
    link: 'https://www.ocr.org.uk/qualifications/as-and-a-level/physics-a-h156-h556-from-2015/',
    buttonText: 'Curriculum',
  },
];

export function WorkContent() {
  return (
    <section className="page-shell">
      <WorkIntroduction />
      <div className="cards-grid">
        {workItems.map((item) => (
          <ProjectCard key={item.title} {...item} />
        ))}
      </div>
    </section>
  );
}
